import { render, staticRenderFns } from "./jobs_slider.vue?vue&type=template&id=665bc0e7&scoped=true"
import script from "./jobs_slider.vue?vue&type=script&lang=js"
export * from "./jobs_slider.vue?vue&type=script&lang=js"
import style0 from "./jobs_slider.vue?vue&type=style&index=0&id=665bc0e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665bc0e7",
  null
  
)

export default component.exports